module.exports = __webpack_public_path__ + "static/media/cook_wink.a3a2f5d3.svg";